import { Sector } from '@/domain/impact/impact.entity.ts';
import { Co2Section } from '@/domain/impact-co2/entities/question.entity';
import { Co2QuizFormData } from '@/ui/pages/app/components/quiz-panel/co2/Co2QuizFormData';

const formDataSite: Co2QuizFormData = {
  sector: 'SITE',
  sections: [
    {
      sectionKey: Co2Section.SCENOGRAPHY,
      questions: ['SCENOGRAPHY_NO_RECYCLABLE', 'SCENOGRAPHY_RECYCLABLE'],
    },
    {
      sectionKey: Co2Section.MATERIAL,
      questions: ['OFFICE_SUPPLIES_NEW', 'OFFICE_SUPPLIES_REFURBISH'],
    },
    {
      sectionKey: Co2Section.BUILDING,
      questions: ['BUILDING_HEATING'],
    },
    {
      sectionKey: Co2Section.ENERGY,
      questions: ['ENERGY', 'GENERATOR'],
    },
    {
      sectionKey: Co2Section.WATER,
      questions: ['WATER'],
    },
    {
      sectionKey: Co2Section.WASTE,
      questions: ['RECYCLABLE_WASTE', 'NON_RECYCLABLE_WASTE'],
    },
    {
      sectionKey: Co2Section.EQUIPMENT,
      questions: ['EQUIPMENT'],
    },
  ],
};

const formDataTeam: Co2QuizFormData = {
  sector: 'TEAM',
  sections: [
    {
      sectionKey: Co2Section.TRANSPORT,
      questions: ['TEAM_MOBILITY'],
    },
    {
      sectionKey: Co2Section.CATERING,
      questions: ['CATERING_MEAL'],
    },
  ],
};
const formDataPublic: Co2QuizFormData = {
  sector: 'PUBLIC',
  sections: [
    {
      sectionKey: Co2Section.CATERING,
      questions: ['CATERING_MEAL', 'CATERING_BEVERAGE'],
    },
    {
      sectionKey: Co2Section.DIGITAL,
      questions: ['DIGITAL'],
    },
  ],
};

export const venueStructureCo2FormData: Record<
  Sector,
  Co2QuizFormData | undefined
> = {
  SITE: formDataSite,
  TEAM: formDataTeam,
  ARTISTS: undefined,
  PUBLIC: formDataPublic,
  '': undefined,
  ANY: undefined,
};
